// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-base-url.js to modify the generation of this file.
export const baseUrl = 'https://talkmore.no';
